import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RequestResponse } from '../model/dto/RequestResponse';
import { Shipment } from '../model/Shipment';

@Injectable()
export class ShipmentFacade {
    private _urlBase: string;
    private _httpClient: HttpClient;

    constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
        this._urlBase = baseUrl;
        this._httpClient = http;
    }

    GetAll(): Observable<RequestResponse<[Shipment]>> {
        return this._httpClient.get<RequestResponse<[Shipment]>>(this._urlBase + 'api/Shipment/All');
    }

    Get(idStore): Observable<RequestResponse<[Shipment]>> {
        return this._httpClient.get<RequestResponse<[Shipment]>>(this._urlBase + 'api/Shipment/ByStore/' + idStore);
    }

    GetByDates(startDate, endDate,organizationId,storeId): Observable<RequestResponse<[Shipment]>> {
        return this._httpClient.get<RequestResponse<[Shipment]>>(this._urlBase
            + 'api/Shipment/ByDates?startDate=' + startDate + '&endDate=' + endDate + '&OrganizationId=' + organizationId + '&StoreId='+storeId);
    }
}
